<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('registers.employees.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-primary" @click="backToRegister">
                    <i class="fas fa-th-list"></i>
                    {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('personalData') }}</div>
                </div>
                <div class="card-body">
                    <person :person="employee.person"
                            :showExtended="true"
                            :show-institution="true"></person>

                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.employees.gridHeaders.workData') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-md-12 col-lg-6 col-xl-6">
                            <label class="font-weight-bold" :for="'manager' + _uid">
                                {{
                                $t('registers.employees.gridHeaders.manager')
                                }}
                            </label>
                            <input type="text" class="form-control" :id="'manager' + _uid"
                                   v-model="employee.manager" readonly>
                        </div>
                        <div class="form-group col-md-12 col-lg-6 col-xl-6">
                            <label class="font-weight-bold" :for="'directorate' + _uid">
                                {{
                                $t('registers.employees.gridHeaders.directorate')
                                }}
                            </label>
                            <input type="text" class="form-control" :id="'directorate' + _uid"
                                   v-model="employee.directorate" readonly>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12 col-lg-6 col-xl-6">
                            <label class="font-weight-bold" :for="'administrativePostion' + _uid">
                                {{
                                $t('administrativePosition.title')
                                }}
                            </label>
                            <input type="text" class="form-control" :id="'workPhone' + _uid"
                                   v-model="employee.administrativePosition" readonly>
                        </div>
                        <div class="form-group col-md-12 col-lg-6 col-xl-6">
                            <label class="font-weight-bold" :for="'workPhone' + _uid">
                                {{
                                $t('registers.employees.gridHeaders.workPhone')
                                }}
                            </label>
                            <input type="text" class="form-control" :id="'workPhone' + _uid"
                                   v-model="employee.workPhone" readonly>
                        </div>
                        <div class="form-group col-md-12 col-lg-6 col-xl-6">
                            <label class="font-weight-bold" :for="'leavingDate' + _uid">
                                {{$t('registers.employees.gridHeaders.leavingDate')}}
                            </label>
                            <div id="'leavingDate' + _uid">
                                <date-picker v-model="employee.leavingDate" :showTime="false" readonly/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.employees.activityЕvaluation') }}</div>
                </div>
                <div class="card-body">
                    <div class="row pt-2 eval-item my-2" v-for="(item, index) in evals" :key="'eval'+index">
                        <div class="col-md-4 form-group">
                            <label class="font-weight-bold" :for="'directorate' + _uid">{{ $t('registers.employees.year') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="item.year"
                                   :name="'eval'+index"
                                   readonly
                                   :data-vv-as="$t('registers.employees.evaluation')" />
                        </div>
                        <div class="col-md-4 form-group">
                            <label class="font-weight-bold" :for="'directorate' + _uid">{{ $t('registers.employees.evaluation') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="item.evaluation"
                                   :name="'eval'+index"
                                   readonly
                                   :data-vv-as="$t('registers.employees.evaluation')" />
                        </div>
                        <div class="col-md-4 form-group">
                            <label class="font-weight-bold" :for="'directorate' + _uid">{{ $t('attachment') }}</label>
                            <div>
                                <file-crud :file="item.attachment"
                                           :editable="item.attachment.id ? false : true"
                                           :readonly="true"
                                           :showDescription="false"
                                           :type="item.attachment.docTypeCode">
                                </file-crud>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3" v-if="employee">
                <AuxiliaryRegisterDetails :entryId="employee.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import PersonComponent from '@/components/person/PersonDetails';
    import { EmployeeDetails } from '@/models/models'
    import PageTitle from '@/components/common/PageTitle';
    import FileCrud from '@/components/common/FileCRUD';
    import { Culture } from "@/models/enums";
    import AuxiliaryRegisterDetails from '@/components/dynamic/AuxiliaryRegisterDetails'
    import DatePicker from '@/components/datepicker/DateTimePicker';

    export default {
        components: {
            'person': PersonComponent,
            PageTitle,
            FileCrud,
            AuxiliaryRegisterDetails,
            DatePicker
        },
        data() {
            return {
                id: '',
                loading: false,
                employee: new EmployeeDetails(),
            }
        },
        methods: {
            backToRegister() {
                this.$router.back();
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/Employee/GetDetails/${this.id}`).then(result => {
                    this.employee = new EmployeeDetails(result.data);
                }).catch(error => {
                    // TODO:
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
        },
        computed: {
            evals() {
                return this.employee.activityЕvaluations.filter(
                    item => !item.isDeleted
                );
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>

